import React from "react";

export interface PageHeroProps {
  icon?: React.ReactNode;
  title?: string;
  titleContent?: React.ReactNode;
  subtitle?: string;
  badge?: React.ReactNode;
  stats?: React.ReactNode;
  className?: string;
  centered?: boolean;
}

const PageHero: React.FC<PageHeroProps> = ({
  icon,
  title = "",
  titleContent,
  subtitle,
  badge,
  stats,
  className = "",
  centered = false,
}) => (
  <div
    className={[
      "dashboard-hero",
      "page-hero",
      !icon ? "dashboard-hero--no-icon" : "",
      centered ? "dashboard-hero--centered" : "",
      className,
    ]
      .filter(Boolean)
      .join(" ")}
  >
    {icon ? (
      <div className="dashboard-hero__icon" aria-hidden="true">
        {icon}
      </div>
    ) : null}
    <div className="dashboard-hero__body">
      {titleContent ?? (
        <h1 className="dashboard-hero__title h5">{title}</h1>
      )}
      {subtitle ? (
        <small className="dashboard-hero__subtitle">{subtitle}</small>
      ) : null}
    </div>
    {badge}
    {stats}
  </div>
);

export default PageHero;
